import styled from 'styled-components';

export const Section = styled.section`
  width: 100%;
  margin-top: 28px;
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
  flex-wrap: wrap;
`;

export const Title = styled.h3`
  margin: 0 0 2px;
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: 12.5px;
  color: ${({ theme }) => theme.colors.text.secondary};
  max-width: 560px;
  line-height: 1.5;
`;

export const TableWrap = styled.div`
  width: 100%;
  overflow-x: auto;
  background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.02)' : '#ffffff')};
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : '#e5e7eb')};
  border-radius: 12px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  thead th {
    text-align: left;
    padding: 12px 16px;
    font-size: 11px;
    letter-spacing: 0.04em;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.text.muted};
    background: ${({ theme }) => theme.colors.background.tertiary};
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
  }

  tbody tr {
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
  }
  tbody tr:last-child { border-bottom: none; }

  tbody td {
    padding: 10px 16px;
    vertical-align: middle;
    color: ${({ theme }) => theme.colors.text.primary};
  }
  tbody td.right { text-align: right; }
  tbody td.muted { color: ${({ theme }) => theme.colors.text.secondary}; }
`;

export const DeviceName = styled.div`
  font-size: 13px;
  font-weight: 300;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const DeviceMeta = styled.div`
  font-size: 11.5px;
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const StatusPill = styled.span<{ $online: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 300;
  background: ${({ $online, theme }) => {
    if ($online) return theme.mode === 'dark' ? 'rgba(34, 197, 94, 0.14)' : '#dcfce7';
    return theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : '#f3f4f6';
  }};
  color: ${({ $online, theme }) => {
    if ($online) return theme.mode === 'dark' ? '#86efac' : '#15803d';
    return theme.colors.text.secondary;
  }};

  &::before {
    content: '';
    display: inline-block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: ${({ $online }) => ($online ? '#22c55e' : '#9ca3af')};
  }
`;

export const IconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  background: transparent;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
  color: #dc2626;

  &:hover:not(:disabled) {
    background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(239, 68, 68, 0.12)' : '#fee2e2')};
    border-color: #fecaca;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg { width: 14px; height: 14px; }
`;

export const EmptyContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  gap: 6px;
  text-align: center;
`;

export const EmptyTitle = styled.p`
  margin: 0;
  font-size: 13px;
  font-weight: 300;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const EmptyDescription = styled.p`
  margin: 0;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
  max-width: 420px;
  line-height: 1.5;
`;
